export class AuthChannel extends BroadcastChannel {
	constructor() {
		super("web-global-authentication-broadcast-channel");
	}

	public override postMessage(message: AuthChannelMessage): void {
		super.postMessage(message);
	}

	public override addEventListener(
		type: "message",
		listener: EventListenerObject | ((this: this, ev: MessageEvent<AuthChannelMessage>) => void | Promise<void>),
		options?: AddEventListenerOptions,
	): void {
		super.addEventListener(type, listener as EventListener, options);
	}
}

export type AuthChannelMessage = { kind: "error"; error: Error; state: string } | { kind: "success"; state: string };
